import React, { useEffect } from "react";
import MultiRangeSlider from "../MultiRangeSlider/MultiRangeSlider";
import { useDispatch, useSelector } from "react-redux";
import { setMaxValue, setMinValue } from "../../appState/slices/auth/authSlice";

const PriceDropDown = ({updateSelectedFilter}) => {
    const minValue = useSelector((state) => state.product.minValue);
    const maxValue = useSelector((state) => state.product.maxValue);
    useEffect(() => {
        updateSelectedFilter("price");
    })
    const dispatch = useDispatch();
    const handlePriceRange =({ min, max }) => {
        dispatch(setMinValue(min));
        dispatch(setMaxValue(max));
    }
    return (
        <div className="pricedropdown">
            <MultiRangeSlider
                min={minValue - 10000}
                max={maxValue + 10000}
                onChange={({ min, max }) => handlePriceRange({ min, max })}
            />
        </div>
    )
};

export default PriceDropDown;